import {ReactComponent as Question} from '../../../../assets/Icons/Question.svg'
import {BaseModal} from '../../../../components/BaseModal/BaseModal'
import {DialogSetup} from '../../../Dialog/components/DialogSetup/DialogSetup'
import {useState} from 'react'
import {CONVERSATIONS_HELPFILE} from '../../../../constants/helpFileLinksConstants'
import styles from './CreateDialogModal.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../Translation/English/dialog'

interface ICreateDialogModalProps {
  showModal: boolean
  closeModal: () => void
}

export const CreateDialogModal: React.FC<ICreateDialogModalProps> = ({
  showModal,
  closeModal,
}) => {
  const [content, setContent] = useState<React.ReactNode>(null)

  const wt = useWt()

  const getHeader = (): React.ReactElement => {
    return (
      <div className={styles.title}>
        {wt(DIALOG.newConversation)}
        <a href={CONVERSATIONS_HELPFILE} target="_blank" rel="noreferrer">
          <Question />
        </a>
      </div>
    )
  }

  return (
    <BaseModal
      visible={showModal}
      headerTitle={getHeader()}
      onCloseModal={() => closeModal()}
      maxWidth="750px"
      footer={content}
    >
      <div className={styles.createDialog}>
        <DialogSetup
          uploadImages={false}
          closeModal={closeModal}
          setContent={setContent}
        />
      </div>
    </BaseModal>
  )
}
